import React from 'react'
import Modal from '../../../../components/Modal'

/**
 * A modal, or nothing at all.
 *
 * History and OpeningDraft each open on their own AND appear as a tab of the
 * editor workspace. Embedded, the workspace already owns the modal and the
 * chrome, so a second one would nest a dialog inside a dialog. This lets both
 * components keep one render path instead of a duplicated body that has to be
 * kept in step.
 */
const Shell = ({ embedded, open, handleClose, children }) => {
  if (embedded) return children

  return (
    <Modal open={open} handleClose={handleClose}>
      {children}
    </Modal>
  )
}

export default Shell
